import { CustomBrandComponents } from 'typings/brands'
import styled from 'styled-components'
import clientInfo from '../clientInfo'

const { getCSRNumber } = clientInfo.customerSupport

export const ContactUsPhoneNumber: CustomBrandComponents['ContactUsPhoneNumber'] =
  ({ icon }) => {
    return (
      <>
        {icon}
        <span>{getCSRNumber()}</span>
      </>
    )
  }

const BusinessHoursGrid = styled.div`
  display: grid;
  row-gap: 0.27em;
  grid-template-columns: 10em 1fr;
`

export const ContactUsBusinessHours: CustomBrandComponents['ContactUsBusinessHours'] =
  ({ i18n }) => {
    return (
      <BusinessHoursGrid>
        <span>{i18n({ clientInfo: 'Monday - Friday' })}</span>
        <span>{i18n({ clientInfo: '08:00 AM - 01:00 AM EST' })}</span>
        <span>{i18n({ clientInfo: 'Saturday & Sunday' })}</span>
        <span>{i18n({ clientInfo: '09:00 AM - 10:00 PM EST' })}</span>
      </BusinessHoursGrid>
    )
  }
